export default __webpack_public_path__ + "static/media/inicio.0554fd2e.svg";